<template>
    <div v-if="getModalGroups.show">
        <div
                :class="['ap2-modal ap2-modal-md  ap2-scrollbar ap2-modal-short ap2-modal-scrollable  ap2-modal-scrollable-short', getModalGroups.show ? 'open': null]"
                id="marketplace-modal">
            <div class="modal-wrapper">
                <div class="ap2-modal-header">
                    <div class="modal-header-title-wrapper">
                        <div class="modal-header-reference">
                            Duplicate group: {{ group.name }}
                        </div>
                        <div class="modal-header-title mt-2 d-flex align-items-center">
                            <div>
                                Select accounts you want to duplicate this group to
                            </div>
                        </div>
                    </div>
                    <div class="modal-header-close close-modal-demo">
                        <svg @click="close()"
                             height="1em"
                             viewBox="0 0 384 512"
                             xmlns="http://www.w3.org/2000/svg">
                            <path class="svg-fill"
                                  d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
                        </svg>
                    </div>
                </div>
                <div class="ap2-modal-content">
                    <div class="modal-actions-header">
                        <i class="fa-solid fa-circle-info fa-lg" style="color: #459bf8;"></i>
                        <span class="info-message"> Only paremeters will be duplicated, not elements</span>
                        <div class="pull-right">
                            <div class="search-extensible active">
                                <input :value="searchValue"
                                       @input="searchValue=$event.target.value"
                                       type="text"
                                       class="input active"
                                       placeholder="Search">
                                <span v-if="searchValue"
                                      @click="resetSearchValue()"
                                      class="icon"
                                      :style="['mask-image: url(' + plusSolid + ')', 'mask-repeat: no-repeat',
                      'mask-position: center', 'mask-size: 11px', 'background-color: var(--overAppContainerColorMedium)',
                      'transform: rotate(45deg)']"></span>
                                <span v-else class="icon" :style="'-webkit-mask-image: url(' + search + ')'"></span>
                            </div>
                        </div>
                    </div>
                    <perfect-scrollbar>
                        <div v-if="loading" class="text-center">
                            <i class="fas fa-spinner fa-spin"></i> Loading accounts
                        </div>
                        <div v-else v-for="account in filterAccounts"
                             :key="account.id"
                             class="entity-wrapper">
                            <div :class="['entity-header', account.account.network, 'ap2-toggle-collapse-entity']"
                                 data-ap2-target-entity="#test2">
                                <div class="entity-row">
                                    <div class="status-wrapper">
                                        <div class="active" tooltip="Active"></div>
                                        <div class="paused" tooltip="Paused"></div>
                                    </div>
                                    <input v-model="selectedAccounts"
                                           :value="account.id"
                                           class="entity-checkbox" type="checkbox">
                                    <div class="app-entity-labels">
                                        <div :class="['entity-rounded-button', account.account.network]"
                                             :tooltip="account.account.network">
                            <span :style="'background-image: url(' + getPlatformImage(account.account.network) + ')'">
                            </span>
                                        </div>
                                    </div>
                                    <ul class="entity-item">
                                        <li class="entity-name">
                                            {{ account.account.name }}
                                        </li>
                                        <li class="entity-id">
                                            {{ account.account.identifier }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </perfect-scrollbar>
                </div>
                <div class="ap2-modal-footer modal-controls">
                    <div class="modal-controls">
                        <button @click="close()"
                                type="button" class="ap2-btn btn btn-dark close-modal-demo">Cancel
                        </button>

                        <button @click="duplicateGroup()"
                                :disabled="selectedAccounts.length === 0"
                                :tooltip="selectedAccounts.length === 0 ? 'You must select at least one account' : null"
                                type="button" class="ap2-btn btn btn-success close-modal-demo modal-footer-button-link">
                            Duplicate group
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import {PerfectScrollbar} from 'vue3-perfect-scrollbar';
    import plusSolid from '@/assets/images/plus-solid.svg';
    import search from '@/assets/images/magnifying-glass-solid.svg';
    import facebookImage from "@/assets/images/facebook.svg"
    import googleImage from "@/assets/images/google.svg"
    import systemImage from "@/assets/images/code.svg";
    import twitterImage from "@/assets/images/twitter-x.svg";
    import tiktokImage from "@/assets/images/tiktok.svg";
    import dv360Image from "@/assets/images/DV360.svg";

    export default {
        name: 'ModalGroups',
        components: {
            PerfectScrollbar
        },
        data() {
            return {
                page: 0,
                pageSize: 14,
                accounts: [],
                searchValue: null,
                showDropdown: false,
                loading: false,
                selectedAccounts: [],
                plusSolid: plusSolid,
                search: search,
                group: null
            }
        },
        computed: {
            ...mapGetters(['getModalGroups', 'getConstants']),
            filterAccounts() {
                let toReturn = this.accounts
                if (this.searchValue) {
                    toReturn = _.filter(this.accounts, account => _.toLower(account.account.name).includes(_.toLower(this.searchValue)))
                }
                return toReturn
            },
        },
        created() {
            window.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    this.close();
                }
            });
        },
        mounted() {
            this.$store.watch(state => state.modalGroups, async (value) => {
                if (value.show === true) {
                    this.group = this.getModalGroups.data.group;
                    await this.loadAccounts();
                }
            }, {deep: true});
        },
        methods: {
            async loadAccounts() {
                this.loading = true;
                this.accounts = this.getModalGroups.data.accounts;
                this.loading = false;
            },
            close() {
                _.set(this.getModalGroups, 'show', false);
                _.set(this.getModalGroups, 'data', null);
                this.selectedAccounts = [];
            },
            duplicateGroup() {
                _.set(this.getModalGroups, 'show', false);
                _.set(this.getModalGroups, 'data', null);
                _.set(this.getModalGroups, 'result', {'accounts': this.selectedAccounts, 'group': _.cloneDeep(this.group)});
                this.selectedAccounts = [];
            },
            resetSearchValue() {
                this.searchValue = null;
            },
            getPlatformImage(network) {
                if (network === this.getConstants.APP_TYPE_FACEBOOK) {
                    return facebookImage;
                } else if (network === this.getConstants.APP_TYPE_GOOGLE) {
                    return googleImage;
                } else if (network === this.getConstants.APP_TYPE_TIKTOK) {
                    return tiktokImage;
                } else if (network === this.getConstants.APP_TYPE_DV360) {
                    return dv360Image;
                } else if (network === this.getConstants.APP_TYPE_TWITTER) {
                    return twitterImage;
                }
            },
        }
    }
</script>
<style lang="scss">
.entity-selector {
    min-height: 100px;
}
</style>
